import React, { useState } from "react"
import { Grid, Checkbox, FormControlLabel, FormGroup } from "@material-ui/core"
import { TextArea } from "@/popups/components/TextArea"
import useStyles from "@/popups/components/CheckboxSelector/styles"

export type SelectOption = { value: string; label: string }

export type CheckboxSelectorProps = {
	options: SelectOption[]
	value: string[]
	onChange: (value: string[]) => void
	allowOther?: boolean
	otherText?: string
	onOtherTextChange?: (text: string) => void
}

export const CheckboxSelector: React.FC<CheckboxSelectorProps> = ({
	options,
	value,
	onChange,
	allowOther = false,
	otherText = "",
	onOtherTextChange
}) => {
	const [isOtherChecked, setIsOtherChecked] = useState(false)
	const classes = useStyles()

	const handleChange = (optionValue: string, checked: boolean) => {
		const next = checked ? [...value, optionValue] : value.filter((selectedValue) => selectedValue !== optionValue)
		onChange(next)
	}

	const handleOtherToggle = (checked: boolean) => {
		setIsOtherChecked(checked)
		if (!checked) onOtherTextChange?.("")
	}

	return (
		<FormGroup>
			{options.map((option) => (
				<FormControlLabel
					key={option.value}
					control={
						<Checkbox
							color="primary"
							size="small"
							checked={value.includes(option.value)}
							onChange={(event) => handleChange(option.value, event.target.checked)}
						/>
					}
					label={option.label}
				/>
			))}

			{allowOther && (
				<>
					<FormControlLabel
						control={
							<Checkbox
								color="primary"
								size="small"
								checked={isOtherChecked}
								onChange={(event) => handleOtherToggle(event.target.checked)}
							/>
						}
						label="Outro"
					/>
					{isOtherChecked && (
						<Grid item className={classes.textAreaWrapper}>
							<TextArea
								value={otherText}
								onChange={(text) => onOtherTextChange?.(text)}
								placeholder="Descreva aqui..."
							/>
						</Grid>
					)}
				</>
			)}
		</FormGroup>
	)
}
